// extracted by mini-css-extract-plugin
module.exports = {"card":"NFTCard_card__3_KA9","icon":"NFTCard_icon__uhi2r","description":"NFTCard_description__23QOn","collection":"NFTCard_collection__1WlwJ","name":"NFTCard_name__3xX_s"};